import { type UseFormReturn } from 'react-hook-form';
import { useIntl } from 'react-intl';

import { type EditReservationFormSchema } from 'src/features/reservations/components/modals/EditReservationModal';
import { reservationMessages } from 'src/features/reservations/utils/messages.ts';
import { FormFieldBlockSeparator } from 'src/registry/components/blocks/FormFieldBlock.tsx';
import {
    Form,
    FormControl,
    FormControlStack,
    FormField,
    FormItem,
    FormLabel,
    FormMessage,
} from 'src/registry/ui/Form.tsx';
import { Input } from 'src/registry/ui/Input.tsx';

interface ReservationFormProps {
    form: UseFormReturn<EditReservationFormSchema>;
    onSubmit: () => void;
    inParking?: boolean;
}

const ReservationForm = ({ form, onSubmit, inParking }: ReservationFormProps) => {
    const { formatMessage } = useIntl();

    return (
        <Form form={form} onSubmit={form.handleSubmit(onSubmit)}>
            <div className="-mb-4 font-black">{formatMessage(reservationMessages.clientInformation)}</div>
            <FormFieldBlockSeparator />
            <FormField
                control={form.control}
                name="client_name"
                render={({ field }) => (
                    <FormItem variant="dialog">
                        <FormLabel variant="dialog" required>
                            {formatMessage(reservationMessages.name)}
                        </FormLabel>
                        <FormControlStack>
                            <FormControl>
                                <Input type="text" {...field} />
                            </FormControl>
                            <FormMessage />
                        </FormControlStack>
                    </FormItem>
                )}
            />
            <FormField
                control={form.control}
                name="client_email"
                render={({ field }) => (
                    <FormItem variant="dialog">
                        <FormLabel variant="dialog" required>
                            {formatMessage(reservationMessages.email)}
                        </FormLabel>
                        <FormControlStack>
                            <FormControl>
                                <Input type="email" {...field} />
                            </FormControl>
                            <FormMessage />
                        </FormControlStack>
                    </FormItem>
                )}
            />
            <FormField
                control={form.control}
                name="client_phone"
                render={({ field }) => (
                    <FormItem variant="dialog">
                        <FormLabel variant="dialog">{formatMessage(reservationMessages.phoneNumber)}</FormLabel>
                        <div className="flex w-full gap-4">
                            <FormControl>
                                <Input type="tel" {...field} />
                            </FormControl>
                            {/*<FormMessage />*/}
                        </div>
                    </FormItem>
                )}
            />
            <div className="-mb-4 font-black">{formatMessage(reservationMessages.vehicleDetails)}</div>
            <FormFieldBlockSeparator />
            <FormField
                control={form.control}
                name="license_plate"
                render={({ field }) => (
                    <FormItem variant="dialog">
                        <FormLabel variant="dialog" required>
                            {formatMessage(reservationMessages.licensePlate)}
                        </FormLabel>
                        <FormControlStack>
                            <FormControl>
                                <Input type="text" {...field} value={field.value ?? ''} disabled={inParking} />
                            </FormControl>
                            <FormMessage />
                        </FormControlStack>
                    </FormItem>
                )}
            />
        </Form>
    );
};

export default ReservationForm;
